import './App.css';

import { Route, Routes } from 'react-router-dom';

import HomePage from './pages/HomePage';
import HowToPage from './pages/HowToPage';
import PricingPage from './pages/PricingPage';
import ShareableMenu from './pages/ShareableMenu';
import WhatIs from './pages/WhatIs';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/menu-translation" element={<HowToPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/share/:sessionId" element={<ShareableMenu />} />
      <Route path="/what-is/:dish" element={<WhatIs />} />
    </Routes>
  );
}

export default App;
